import { Component, Input } from '@angular/core';
import { Clipboard } from '@angular/cdk/clipboard';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Overlay } from '@angular/cdk/overlay';

@Component({
  selector: 'app-hidden-copy-display',
  templateUrl: './hidden-copy-display.component.html',
  styleUrl: './hidden-copy-display.component.scss'
})
export class HiddenCopyDisplayComponent {
  @Input() value = '';
  @Input() textDescription = '';

  showValue = false;

  constructor(private clipboard: Clipboard, private snackBar: MatSnackBar, private overlay: Overlay) { }

  copy() {
    const copySuccess = this.clipboard.copy(this.value);

    if (copySuccess) {
      this.snackBar.open(`Copied ${this.textDescription} to clipboard.`, 'Dismiss', {
        verticalPosition: 'top',
        horizontalPosition: 'center',
        duration: 5 * 1000
      });
    }
  }

}
